import axios from "axios";
import { baseApiUrl, getHttpHeaders, httpRequest } from "./ApiUtils";

const empInquiryApiUrl = `${baseApiUrl}/api/Employees/Inquiry`;

export async function getInquiryQuestionsByToken(token) {
    return await httpRequest(fetchInquiryQuestionsByToken.bind(this,token));
}

async function fetchInquiryQuestionsByToken(token) {
    let config = getHttpHeaders();
    return await axios.get(`${empInquiryApiUrl}?Token=${token}`, config);
}

export async function updateInquiryResponses(token, questions) {
    return await httpRequest(putInquiryResponses.bind(this, token, questions));
}

async function putInquiryResponses(token, questions) {
    let config = getHttpHeaders();
    return await axios.put(`${empInquiryApiUrl}`, {...questions, token}, config);
}

export async function getInquiryImageByToken(token) {
    return await axios.get(`${empInquiryApiUrl}/Image?Token=${token}`)
}

export async function updateInquiryImage(data) {
    return await axios({
        method: "put",
        url: `${empInquiryApiUrl}/Image`,
        data: data,
        headers: { "Content-Type": "multipart/form-data" },
    })
}
